$(document).ready(function () {
  let hoverTimeout;

  function activateDropdown(menuItem) {
    $(menuItem).addClass("active");
    $(menuItem).find(".mega-sub-menu").addClass("active");
  }

  function deactivateDropdown(menuItem) {
    $(menuItem).removeClass("active");
    $(menuItem).find(".mega-sub-menu").removeClass("active");
  }

  // Handle hover events
  $(".header__menu-item.has-dropdown")
    .mouseenter(function () {
      clearTimeout(hoverTimeout);
      activateDropdown(this);
    })
    .mouseleave(function (event) {
      hoverTimeout = setTimeout(() => {
        if (!$(this).find(".mega-sub-menu").is(event.relatedTarget)) {
          deactivateDropdown(this);
        }
      }, 300);
    });

  $(".mega-sub-menu.dropdown-child")
    .mouseenter(function () {
      clearTimeout(hoverTimeout);
      activateDropdown($(this).closest(".header__menu-item.has-dropdown"));
    })
    .mouseleave(function (event) {
      hoverTimeout = setTimeout(() => {
        if (!$(this).is(event.relatedTarget)) {
          deactivateDropdown(
            $(this).closest(".header__menu-item.has-dropdown")
          );
        }
      }, 300);
    });

  // Handle scroll events to keep submenu visible until scrolling past 400px
  $(window).scroll(function () {
    if ($(this).scrollTop() >= 400) {
      $(".header__menu-item.has-dropdown").removeClass("active");
      $(".mega-sub-menu").removeClass("active");
    } else {
      // Optionally, re-activate if the scroll goes back up
      // $('.header__menu-item.has-dropdown').addClass('active');
      // $('.mega-sub-menu').addClass('active');
    }
  });

  // Additional check if any submenu is active and keep the parent menu item active
  $(".header__menu-item.has-dropdown").mouseleave(function () {
    let isActive = false;
    $(this)
      .find(".mega-sub-menu")
      .each(function () {
        if ($(this).hasClass("active")) {
          isActive = true;
        }
      });
    if (!isActive) {
      deactivateDropdown(this);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const menuBackdrop = document.getElementById("menu-backdrop");

  document.querySelectorAll(".mega-menu").forEach(function (megaMenu) {
    const summary = megaMenu.querySelector("summary");
    let closeMenuTimeout;

    summary.addEventListener("mouseenter", function () {
      clearTimeout(closeMenuTimeout);
      megaMenu.setAttribute("open", "true");
      menuBackdrop.style.display = "block";
    });

    megaMenu.addEventListener("mouseenter", function () {
      clearTimeout(closeMenuTimeout);
    });

    megaMenu.addEventListener("mouseleave", function () {
      closeMenuTimeout = setTimeout(function () {
        megaMenu.removeAttribute("open");
        menuBackdrop.style.display = "none";
      }, 300);
    });
  });

  menuBackdrop.addEventListener("click", function () {
    document.querySelectorAll(".mega-menu").forEach(function (megaMenu) {
      megaMenu.removeAttribute("open");
    });
    menuBackdrop.style.display = "none";
  });
});
